import indifferentLoggerListener from '../common';
import isDev from '../../../helpers/isDev';
import logToConsole from './logToConsole';
import logRemotely from './logRemotely';

export const actions = {
    logToConsole,
    logRemotely
};

/**
 * Listen to global event bus on LOGGER events
 * @param  {String} options.host
 * @param  {String} options.facility
 * @param  {String} options.logLevel
 * @param  {String} [options.mode]   'dev' or not
 * @param  {Object} [options.context] data passed into relaySDK.registerContext method
 * @return {Logger}
 */
export default function loggerListener({ host, facility, logLevel = 'error', mode = 'production', context }) {
    const action = isDev(mode)
        ? actions.logToConsole()
        : actions.logRemotely({ host, facility, context });

    return indifferentLoggerListener({ action, logLevel });
}
